import React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import Link from "@mui/material/Link"
import CircularIndeterminate from "../feedback/CircularIndeterminate"

interface InfoDialogProps {
	buttonName: string
	title: string
	body: string
	handleClick: () => {}
}

export default function InfoDialog(props: InfoDialogProps) {
	const [open, setOpen] = React.useState(false)

	const handleClickOpen = () => {
		props.handleClick()
		setOpen(true)
	}

	const handleClose = async () => {
		setOpen(false)
	}

	return (
		<div>
			<Link component="button" variant="body2" onClick={handleClickOpen}>
				{props.buttonName}
			</Link>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{props.body === "" ? (
					<div>
						<CircularIndeterminate />{" "}
					</div>
				) : (
					<div>
						<DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">{props.body}</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleClose} color="primary" autoFocus>
								OK
							</Button>
						</DialogActions>
					</div>
				)}
			</Dialog>
		</div>
	)
}
